import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import React, { useEffect } from 'react'
import { Api } from '../../../../redux/api/BaseApi';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { UserApi } from '../../../../redux/api/UserApi';
import {
  Notification,
} from "@progress/kendo-react-notification";
import { Icon } from '@progress/kendo-react-common';
import { SetLastFlaggedNoteConfirmedId } from '../../../../slices/TicketSlice';
import { ClientApi } from '../../../../redux/api/ClientApi';
import { ITicket } from '../../../../types/Ticket/ITicket';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { TextArea } from '@progress/kendo-react-inputs';
import './FlaggedNotes.scss'
import { PartialSpinny } from '../../../Nav/Spinny';
import { setFlaggedNotesExist, setFlaggedNotesExpanded } from '../../../../slices/TicketDetailUISlice';
import { ProjectApi } from '../../../../redux/api/ProjectApi';
import { useCurrentUserContext } from '../../../../context/UserContext';

const FlaggedNotes = ({ ticket, showPopup, showNotes }: { ticket: ITicket, showPopup: boolean, showNotes?: boolean }) => {
  const { profile: userProfile } = useCurrentUserContext();
  const { Company_Contact: endUserId, Company_Address_Id, Company_Id } = ticket//useReduxSelector(s => s.newTicket.ticket)
  const lastFlaggedNoteConfirmedId = useReduxSelector(s => s.newTicket.lastFlaggedNoteConfirmedId)
  const { flaggedNotes } = useReduxSelector(s => s.ticketDetailsUI)
  const { data: contact, isFetching: contactFetching } = UserApi.useGetUserByIdQuery(endUserId, { skip: !endUserId });
  const { data: office, isFetching: officeFetching } = ClientApi.useGetOfficeQuery(Company_Address_Id, { skip: !Company_Address_Id });
  const { data: client, isFetching: clientFetching } = ClientApi.useGetClientQuery(Company_Id, { skip: !Company_Id });
  const { data: project, isFetching: projectFetching } = ProjectApi.useGetProjectQuery(ticket.Project_Id, { skip: !ticket.Project_Id });
  const [updateNotes, { isLoading }] = UserApi.useUpdateNotesMutation();
  const [popupVisible, setPopupVisible] = React.useState(false);
  const [editVisible, setEditVisible] = React.useState(false);
  const [notes, setNotes] = React.useState<string>();
  const dispatch = useReduxDispatch();

  useEffect(() => {
    setNotes(contact?.Notes)
  }, [contact?.Notes])

  //Show the popup when the contact has flagged notes.
  useEffect(() => {
    const clientNotes = client?.Flag_Notes && client?.Notes
    const projectNotes = project?.Flag_Notes && project?.Notes?.length > 0
    const officeNotes = office?.Flag_Notes && office?.Notes
    const contactNotes = contact?.Display_Notes && contact?.Notes
    const isLoading = contactFetching || officeFetching || clientFetching || projectFetching

    if ((clientNotes || officeNotes || contactNotes || projectNotes) && !isLoading && showPopup && userProfile.Features.Popup_Flagged_Notes && lastFlaggedNoteConfirmedId !== endUserId)
      setPopupVisible(true);
  }, [client, office, contact, endUserId])

  function confirmFlaggedNotes() {
    dispatch(SetLastFlaggedNoteConfirmedId(endUserId));
    setPopupVisible(false);
  }

  const saveFlaggedNotes = () => {
    notes && updateNotes({ uid: contact?.UId, Notes: notes }).unwrap();
    setEditVisible(false);
  }

  const clientNotes = (showNotes || client?.Flag_Notes) && client?.Notes
  const projectNotes = (showNotes || project?.Flag_Notes) && project?.Notes?.length > 0
  const officeNotes = (showNotes || office?.Flag_Notes) && office?.Notes
  const contactNotes = (showNotes || contact?.Display_Notes) && contact?.Notes
  const hasAnyNotes = clientNotes || projectNotes || officeNotes || contactNotes
  const hasAnyFlaggedNotes = client?.Flag_Notes || project?.Flag_Notes || office?.Flag_Notes || contact?.Display_Notes

  //Update global state to show the flagged notes expanded if there are any notes.
  useEffect(() => {
    dispatch(setFlaggedNotesExpanded(hasAnyFlaggedNotes))

    dispatch(setFlaggedNotesExist(hasAnyNotes))

  }, [hasAnyNotes, hasAnyFlaggedNotes])


  if ((!hasAnyNotes) || !endUserId) return <></>;

  const display = <div key='5'>
    {contactNotes && <Button key='4' className='edit-button off' svgIcon={svg.pencilIcon} fillMode='flat' onClick={() => setEditVisible(true)}></Button>}
    {contactNotes && <div key='6'><b>{contact.FullName}</b> - {contact?.Notes.split('\n').map(str => <>{str}<br /></>)}</div>}
    {officeNotes && <div key='7'><b>{office.Address_Name}</b> - {office?.Notes.split('\n').map(str => <>{str}<br /></>)}</div>}
    {projectNotes && <div key='8'><b>{project.Project_Name}</b> - {project?.Notes.split('\n').map(str => <>{str}<br /></>)}</div>}
    {clientNotes && <div key='9'><b>{client.Company_Name}</b> - {client?.Notes.split('\n').map(str => <>{str}<br /></>)}</div>}
  </div>



  return (
    <div className='flagged-notes'>
      {flaggedNotes?.expanded && <Notification key='1'
        type={{
          style: "info",
          icon: true,
        }}
        style={{ color: 'black', border: 'none', boxShadow: 'none', borderRadius: '0px', padding: '8px', width: '100%', textAlign: 'left', fontSize: '13px', verticalAlign: 'top' }}
        closable={false}>
        {display}
      </Notification>}
      {popupVisible && userProfile?.Features.Popup_Flagged_Notes &&
        <Dialog key='2' width={Math.min(500, window.innerWidth)} className='flagged-notes cool-window' title={<div className='flex'><Icon name='info' style={{ fontSize: '20px' }} className='pr-6'></Icon>Flagged Notes</div>} onClose={() => confirmFlaggedNotes()} >
          {display}
          <DialogActionsBar>
            <button
              style={{ backgroundColor: '#f5f5f5', color: '#fff' }}
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button-solid-primary"
              onClick={() => confirmFlaggedNotes()}
            >
              OK
            </button>
          </DialogActionsBar>
        </Dialog>}
      {editVisible && <Dialog key='3' width={Math.min(500, window.innerWidth)} height={270} className='cool-window' title={<div className='flex'><Icon name='edit' style={{ fontSize: '20px' }} className='pr-6'></Icon>Edit Flagged Notes</div>} onClose={() => setEditVisible(false)} >
        {isLoading && <PartialSpinny />}
        <TextArea defaultValue={contact.Notes} value={notes} onChange={(e) => setNotes(e.value)} placeholder='Contact notes' rows={6} />
        <DialogActionsBar>
          <Button
            style={{ backgroundColor: '#f5f5f5', color: '#fff' }}
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button-solid-primary"
            onClick={() => saveFlaggedNotes()}
          >
            Save
          </Button>
          <Button onClick={() => setEditVisible(false)} fillMode='outline'>Cancel</Button>
        </DialogActionsBar>
      </Dialog>}
    </div>
  )
}

export default FlaggedNotes